import React, { useEffect, useState } from "react";
import { GoogleMap, MarkerF, DirectionsRenderer } from "@react-google-maps/api";
import { Box } from "@mui/material";

interface LatLng {
  lat: number;
  lng: number;
}

interface Props {
  height?: string;
  zoom?: number;
  origin?: LatLng;
  destination?: LatLng;
  deliveryPartner?:LatLng;
}

const mapContainerStyle = { width: "100%", height: "100%" };
const indiaCenter = { lat: 20.5937, lng: 78.9629 };

const Mapcomponent: React.FC<Props> = ({ height = "100%", zoom = 15, origin, destination,deliveryPartner }) => {
  const [mapInstance, setMapInstance] = useState<google.maps.Map | null>(null);
  const [userLocation, setUserLocation] = useState<LatLng | null>(null);
  const [directions, setDirections] = useState<google.maps.DirectionsResult | null>(null);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => setUserLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
        () => setUserLocation(indiaCenter)
      );
    } else {
      setUserLocation(indiaCenter);
    }
  }, []);

  const defaultCenter = origin || userLocation || indiaCenter;

  useEffect(() => {
    if (mapInstance) {
      setTimeout(() => {
        window.google.maps.event.trigger(mapInstance, "resize");
        mapInstance.setCenter(defaultCenter);
      }, 300);
    }
  }, [mapInstance, defaultCenter]);

  useEffect(() => {
    if (!origin || !destination) { setDirections(null); return; }
    const service = new window.google.maps.DirectionsService();
    service.route(
      { origin, destination, travelMode: window.google.maps.TravelMode.DRIVING },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK && result) setDirections(result);
        else setDirections(null);
      }
    );
  }, [origin?.lat, origin?.lng, destination?.lat, destination?.lng]);

  return (
    <Box sx={{ width: "100%", height }}>
      <GoogleMap mapContainerStyle={mapContainerStyle} center={defaultCenter} zoom={zoom} onLoad={(map) => setMapInstance(map)}>
        {directions ? (
          <>
          <DirectionsRenderer directions={directions} options={{ suppressMarkers: false }} />
          {deliveryPartner && (<MarkerF position={deliveryPartner} label="D"/>
          )}
        </>
        ) : (
          <>
            {origin && <MarkerF position={origin} label="W" />}
            {destination && <MarkerF position={destination} label="C" />}
            {deliveryPartner && (<MarkerF  position={deliveryPartner} label="D"/>
          )}
          </>
        )}
      </GoogleMap>
    </Box>
  );
};

export default Mapcomponent;
